/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  FacadePackingLib,
  FacadePackingLibInterface,
} from "../FacadePackingLib";

const _abi = [
  {
    inputs: [],
    name: "IncompatibleInputString",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "kind",
        type: "uint8",
      },
    ],
    name: "IncorrectOtherItemTypeKind",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "value",
        type: "int256",
      },
    ],
    name: "IntOutOfRange",
    type: "error",
  },
  {
    inputs: [],
    name: "LengthsMismatch",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "OutOfBounds",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TooHighValue",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "expected",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "actual",
        type: "uint256",
      },
    ],
    name: "UnexpectedValue",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroValue",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "arr",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "idx",
        type: "uint256",
      },
      {
        internalType: "int32",
        name: "value",
        type: "int32",
      },
    ],
    name: "changeInt32",
    outputs: [
      {
        internalType: "int32",
        name: "newValue",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "change",
        type: "int32",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "value",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "expectedPrevValue",
        type: "uint8",
      },
    ],
    name: "changeUnit8ArrayWithCheck",
    outputs: [
      {
        internalType: "bytes32",
        name: "newData",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes",
      },
    ],
    name: "decodeAttackInfo",
    outputs: [
      {
        components: [
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "skillTokens",
            type: "address[]",
          },
          {
            internalType: "uint256[]",
            name: "skillTokenIds",
            type: "uint256[]",
          },
        ],
        internalType: "struct IFightCalculator.AttackInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "encoded",
        type: "bytes",
      },
    ],
    name: "decodePvpStrategyDefault",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "behaviourStrategyKind",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "enum IFightCalculator.AttackType",
                name: "attackType",
                type: "uint8",
              },
              {
                internalType: "address",
                name: "attackToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "attackTokenId",
                type: "uint256",
              },
              {
                internalType: "address[]",
                name: "skillTokens",
                type: "address[]",
              },
              {
                internalType: "uint256[]",
                name: "skillTokenIds",
                type: "uint256[]",
              },
            ],
            internalType: "struct IFightCalculator.AttackInfo",
            name: "attackInfo",
            type: "tuple",
          },
        ],
        internalType: "struct IPvpController.PvpStrategyDefault",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "skillTokens",
            type: "address[]",
          },
          {
            internalType: "uint256[]",
            name: "skillTokenIds",
            type: "uint256[]",
          },
        ],
        internalType: "struct IFightCalculator.AttackInfo",
        name: "data",
        type: "tuple",
      },
    ],
    name: "encodeAttackInfo",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "behaviourStrategyKind",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "enum IFightCalculator.AttackType",
                name: "attackType",
                type: "uint8",
              },
              {
                internalType: "address",
                name: "attackToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "attackTokenId",
                type: "uint256",
              },
              {
                internalType: "address[]",
                name: "skillTokens",
                type: "address[]",
              },
              {
                internalType: "uint256[]",
                name: "skillTokenIds",
                type: "uint256[]",
              },
            ],
            internalType: "struct IFightCalculator.AttackInfo",
            name: "attackInfo",
            type: "tuple",
          },
        ],
        internalType: "struct IPvpController.PvpStrategyDefault",
        name: "data",
        type: "tuple",
      },
    ],
    name: "encodePvpStrategyDefault",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "getArr",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "dest",
        type: "bytes32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "idx",
        type: "uint256",
      },
    ],
    name: "getInt32",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "arr_",
        type: "bytes32[]",
      },
      {
        internalType: "uint256",
        name: "idx",
        type: "uint256",
      },
    ],
    name: "getInt32Memory",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "packedData",
        type: "bytes",
      },
    ],
    name: "getOtherItemTypeKind",
    outputs: [
      {
        internalType: "enum IItemController.OtherSubtypeKind",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "packedData",
        type: "bytes",
      },
    ],
    name: "getPvpBehaviourStrategyKind",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "packAddressWithAmount",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "attackToken",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "attackTokenId",
        type: "uint64",
      },
      {
        internalType: "uint8",
        name: "attackType",
        type: "uint8",
      },
    ],
    name: "packAttackInfo",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "biomeMapFieldId",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "territoryNumber",
        type: "uint8",
      },
      {
        internalType: "uint128",
        name: "x",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "y",
        type: "uint128",
      },
    ],
    name: "packBattlefieldId",
    outputs: [
      {
        internalType: "bytes32",
        name: "packedData",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "slot",
        type: "uint8",
      },
      {
        internalType: "uint64",
        name: "chance",
        type: "uint64",
      },
      {
        internalType: "bool",
        name: "stopIfBurned",
        type: "bool",
      },
    ],
    name: "packBreakInfo",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "x",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "y",
        type: "uint128",
      },
    ],
    name: "packCoordinate",
    outputs: [
      {
        internalType: "bytes32",
        name: "packedData",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "customDataIndex",
        type: "bytes32",
      },
      {
        internalType: "int16",
        name: "value",
        type: "int16",
      },
    ],
    name: "packCustomDataChange",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "min",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "max",
        type: "uint64",
      },
      {
        internalType: "bool",
        name: "key",
        type: "bool",
      },
    ],
    name: "packCustomDataRequirements",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "heroAdr",
        type: "address",
      },
      {
        internalType: "uint80",
        name: "heroId",
        type: "uint80",
      },
      {
        internalType: "uint16",
        name: "dungLogicNum",
        type: "uint16",
      },
    ],
    name: "packDungeonKey",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "generated",
        type: "bool",
      },
      {
        internalType: "uint32",
        name: "amplifier",
        type: "uint32",
      },
      {
        internalType: "int32",
        name: "hp",
        type: "int32",
      },
      {
        internalType: "uint8",
        name: "turnCounter",
        type: "uint8",
      },
    ],
    name: "packGeneratedMonster",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32[]",
        name: "data",
        type: "int32[]",
      },
    ],
    name: "packInt32Array",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "attackType",
        type: "uint8",
      },
      {
        internalType: "int32",
        name: "min",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "max",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "factorStr",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "factorDex",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "factorVit",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "factorEng",
        type: "int32",
      },
    ],
    name: "packItemAttackInfo",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "id",
        type: "uint8",
      },
      {
        internalType: "int32",
        name: "min",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "max",
        type: "int32",
      },
      {
        internalType: "uint32",
        name: "chance",
        type: "uint32",
      },
    ],
    name: "packItemGenerateInfo",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "rarity",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "augmentationLevel",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "durability",
        type: "uint16",
      },
    ],
    name: "packItemInfo",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "itemMetaType",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "itemLvl",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "itemType",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "baseDurability",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "defaultRarity",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "minAttr",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "maxAttr",
        type: "uint8",
      },
      {
        internalType: "uint32",
        name: "manaCost",
        type: "uint32",
      },
      {
        components: [
          {
            internalType: "int32",
            name: "strength",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "dexterity",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "vitality",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "energy",
            type: "int32",
          },
        ],
        internalType: "struct IStatController.CoreAttributes",
        name: "req",
        type: "tuple",
      },
    ],
    name: "packItemMeta",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "chance",
        type: "uint32",
      },
    ],
    name: "packItemMintInfo",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "heroAdr",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "heroId",
        type: "uint64",
      },
      {
        internalType: "uint32",
        name: "objId",
        type: "uint32",
      },
    ],
    name: "packIterationKey",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "objectAddress",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "objectId",
        type: "uint64",
      },
      {
        internalType: "uint8",
        name: "objectType",
        type: "uint8",
      },
    ],
    name: "packMapObject",
    outputs: [
      {
        internalType: "bytes32",
        name: "packedData",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "race",
        type: "uint8",
      },
      {
        internalType: "uint32",
        name: "experience",
        type: "uint32",
      },
      {
        internalType: "uint8",
        name: "maxDropItems",
        type: "uint8",
      },
    ],
    name: "packMonsterStats",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "packNftId",
    outputs: [
      {
        internalType: "bytes32",
        name: "serialized",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "value",
        type: "uint32",
      },
    ],
    name: "packNftIdWithValue",
    outputs: [
      {
        internalType: "bytes32",
        name: "serialized",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "packOtherItemReduceFragility",
    outputs: [
      {
        internalType: "bytes",
        name: "packedData",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "heroAdr",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "heroId",
        type: "uint64",
      },
      {
        internalType: "uint8",
        name: "oType",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
    ],
    name: "packPlayedObjKey",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        internalType: "uint128",
        name: "score",
        type: "uint128",
      },
      {
        internalType: "uint8",
        name: "fee",
        type: "uint8",
      },
      {
        internalType: "uint64",
        name: "stakeTs",
        type: "uint64",
      },
    ],
    name: "packReinforcementHeroInfo",
    outputs: [
      {
        internalType: "bytes32",
        name: "packedData",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "shelterLevel",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "shelterIndex",
        type: "uint8",
      },
    ],
    name: "packShelterId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "experience",
        type: "uint32",
      },
      {
        internalType: "int32",
        name: "heal",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "manaRegen",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "lifeChancesRecovered",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "damage",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "manaConsumed",
        type: "int32",
      },
    ],
    name: "packStatsChange",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "pageId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "heroClass",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "answerId",
        type: "uint16",
      },
    ],
    name: "packStoryAnswerId",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "attributeIndex",
        type: "uint8",
      },
      {
        internalType: "int32",
        name: "value",
        type: "int32",
      },
      {
        internalType: "bool",
        name: "isCore",
        type: "bool",
      },
    ],
    name: "packStoryAttributeRequirement",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "pageId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "heroClass",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "answerId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "customDataResultId",
        type: "uint8",
      },
    ],
    name: "packStoryCustomDataResult",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "pageId",
        type: "uint16",
      },
      {
        internalType: "uint40",
        name: "heroLastActionTS",
        type: "uint40",
      },
    ],
    name: "packStoryHeroState",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "heroAdr",
        type: "address",
      },
      {
        internalType: "uint80",
        name: "heroId",
        type: "uint80",
      },
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
    ],
    name: "packStoryHeroStateId",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        internalType: "bool",
        name: "requireItemBurn",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "requireItemEquipped",
        type: "bool",
      },
    ],
    name: "packStoryItemRequirement",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "pageId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "heroClass",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "answerId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "resultId",
        type: "uint8",
      },
    ],
    name: "packStoryNextPagesId",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "pageId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "heroClass",
        type: "uint8",
      },
    ],
    name: "packStoryPageId",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "randomRequirement",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "delayRequirement",
        type: "uint32",
      },
      {
        internalType: "bool",
        name: "isFinalAnswer",
        type: "bool",
      },
    ],
    name: "packStorySimpleRequirement",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint88",
        name: "amount",
        type: "uint88",
      },
      {
        internalType: "bool",
        name: "requireTransfer",
        type: "bool",
      },
    ],
    name: "packStoryTokenRequirement",
    outputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "tier",
        type: "uint8",
      },
      {
        internalType: "address",
        name: "hero",
        type: "address",
      },
    ],
    name: "packTierHero",
    outputs: [
      {
        internalType: "bytes32",
        name: "packedTierHero",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32[]",
        name: "data",
        type: "uint32[]",
      },
    ],
    name: "packUint32Array",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8[]",
        name: "data",
        type: "uint8[]",
      },
    ],
    name: "packUint8Array",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "a",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "b",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "c",
        type: "uint8",
      },
    ],
    name: "packUint8Array3",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "data",
        type: "bytes32[]",
      },
    ],
    name: "setArr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "idx",
        type: "uint256",
      },
      {
        internalType: "int32",
        name: "value",
        type: "int32",
      },
    ],
    name: "setInt32",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32[]",
        name: "arr_",
        type: "int32[]",
      },
    ],
    name: "toBytes32Array",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "data",
        type: "bytes32[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32[]",
        name: "arr_",
        type: "int32[]",
      },
      {
        internalType: "uint8[]",
        name: "ids",
        type: "uint8[]",
      },
    ],
    name: "toBytes32ArrayWithIds",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "data",
        type: "bytes32[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "arr_",
        type: "bytes32[]",
      },
      {
        internalType: "uint256",
        name: "size",
        type: "uint256",
      },
    ],
    name: "toInt32Array",
    outputs: [
      {
        internalType: "int32[]",
        name: "data",
        type: "int32[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "arr_",
        type: "bytes32[]",
      },
    ],
    name: "toInt32ArrayWithIds",
    outputs: [
      {
        internalType: "int32[]",
        name: "valuesOut",
        type: "int32[]",
      },
      {
        internalType: "uint8[]",
        name: "idsOut",
        type: "uint8[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackAddressWithAmount",
    outputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackAttackInfo",
    outputs: [
      {
        internalType: "address",
        name: "attackToken",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "attackTokenId",
        type: "uint64",
      },
      {
        internalType: "uint8",
        name: "attackType",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "packedData",
        type: "bytes32",
      },
    ],
    name: "unpackBattlefieldId",
    outputs: [
      {
        internalType: "uint8",
        name: "biomeMapFieldId",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "territoryNumber",
        type: "uint8",
      },
      {
        internalType: "uint128",
        name: "x",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "y",
        type: "uint128",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackBreakInfo",
    outputs: [
      {
        internalType: "uint8",
        name: "slot",
        type: "uint8",
      },
      {
        internalType: "uint64",
        name: "chance",
        type: "uint64",
      },
      {
        internalType: "bool",
        name: "stopIfBurned",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "packedData",
        type: "bytes32",
      },
    ],
    name: "unpackCoordinate",
    outputs: [
      {
        internalType: "uint128",
        name: "x",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "y",
        type: "uint128",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackCustomDataChange",
    outputs: [
      {
        internalType: "bytes32",
        name: "customDataIndex",
        type: "bytes32",
      },
      {
        internalType: "int16",
        name: "value",
        type: "int16",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackCustomDataRequirements",
    outputs: [
      {
        internalType: "uint64",
        name: "min",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "max",
        type: "uint64",
      },
      {
        internalType: "bool",
        name: "key",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackDungeonKey",
    outputs: [
      {
        internalType: "address",
        name: "heroAdr",
        type: "address",
      },
      {
        internalType: "uint80",
        name: "heroId",
        type: "uint80",
      },
      {
        internalType: "uint16",
        name: "dungLogicNum",
        type: "uint16",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackGeneratedMonster",
    outputs: [
      {
        internalType: "bool",
        name: "generated",
        type: "bool",
      },
      {
        internalType: "uint32",
        name: "amplifier",
        type: "uint32",
      },
      {
        internalType: "int32",
        name: "hp",
        type: "int32",
      },
      {
        internalType: "uint8",
        name: "turnCounter",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackInt32Array",
    outputs: [
      {
        internalType: "int32[]",
        name: "",
        type: "int32[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackItemAttackInfo",
    outputs: [
      {
        internalType: "uint8",
        name: "attackType",
        type: "uint8",
      },
      {
        internalType: "int32",
        name: "min",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "max",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "factorStr",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "factorDex",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "factorVit",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "factorEng",
        type: "int32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackItemGenerateInfo",
    outputs: [
      {
        internalType: "uint8",
        name: "id",
        type: "uint8",
      },
      {
        internalType: "int32",
        name: "min",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "max",
        type: "int32",
      },
      {
        internalType: "uint32",
        name: "chance",
        type: "uint32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackItemInfo",
    outputs: [
      {
        internalType: "uint8",
        name: "rarity",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "augmentationLevel",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "durability",
        type: "uint16",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackItemMeta",
    outputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "itemMetaType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "itemLevel",
            type: "uint8",
          },
          {
            internalType: "enum IItemController.ItemType",
            name: "itemType",
            type: "uint8",
          },
          {
            internalType: "uint16",
            name: "baseDurability",
            type: "uint16",
          },
          {
            internalType: "uint8",
            name: "defaultRarity",
            type: "uint8",
          },
          {
            internalType: "uint32",
            name: "manaCost",
            type: "uint32",
          },
          {
            internalType: "uint8",
            name: "minRandomAttributes",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "maxRandomAttributes",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "int32",
                name: "strength",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "dexterity",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "vitality",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "energy",
                type: "int32",
              },
            ],
            internalType: "struct IStatController.CoreAttributes",
            name: "requirements",
            type: "tuple",
          },
        ],
        internalType: "struct IItemController.ItemMeta",
        name: "result",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackItemMintInfo",
    outputs: [
      {
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "chance",
        type: "uint32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackIterationKey",
    outputs: [
      {
        internalType: "address",
        name: "heroAdr",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "heroId",
        type: "uint64",
      },
      {
        internalType: "uint32",
        name: "objId",
        type: "uint32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "packedData",
        type: "bytes32",
      },
    ],
    name: "unpackMapObject",
    outputs: [
      {
        internalType: "address",
        name: "objectAddress",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "objectId",
        type: "uint64",
      },
      {
        internalType: "uint8",
        name: "objectType",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackMonsterStats",
    outputs: [
      {
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "race",
        type: "uint8",
      },
      {
        internalType: "uint32",
        name: "experience",
        type: "uint32",
      },
      {
        internalType: "uint8",
        name: "maxDropItems",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackNftId",
    outputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackNftIdWithValue",
    outputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "value",
        type: "uint32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "packedData",
        type: "bytes",
      },
    ],
    name: "unpackOtherItemReduceFragility",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackPlayedObjKey",
    outputs: [
      {
        internalType: "address",
        name: "heroAdr",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "heroId",
        type: "uint64",
      },
      {
        internalType: "uint8",
        name: "oType",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "packedData",
        type: "bytes32",
      },
    ],
    name: "unpackReinforcementHeroInfo",
    outputs: [
      {
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        internalType: "uint128",
        name: "score",
        type: "uint128",
      },
      {
        internalType: "uint8",
        name: "fee",
        type: "uint8",
      },
      {
        internalType: "uint64",
        name: "stakeTs",
        type: "uint64",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "shelterId",
        type: "uint256",
      },
    ],
    name: "unpackShelterId",
    outputs: [
      {
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "shelterLevel",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "shelterIndex",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackStatsChange",
    outputs: [
      {
        internalType: "uint32",
        name: "experience",
        type: "uint32",
      },
      {
        internalType: "int32",
        name: "heal",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "manaRegen",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "lifeChancesRecovered",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "damage",
        type: "int32",
      },
      {
        internalType: "int32",
        name: "manaConsumed",
        type: "int32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackStoryAnswerId",
    outputs: [
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "pageId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "heroClass",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "answerId",
        type: "uint16",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackStoryAttributeRequirement",
    outputs: [
      {
        internalType: "uint8",
        name: "attributeIndex",
        type: "uint8",
      },
      {
        internalType: "int32",
        name: "value",
        type: "int32",
      },
      {
        internalType: "bool",
        name: "isCore",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackStoryCustomDataResult",
    outputs: [
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "pageId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "heroClass",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "answerId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "customDataResultId",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackStoryHeroState",
    outputs: [
      {
        internalType: "uint16",
        name: "pageId",
        type: "uint16",
      },
      {
        internalType: "uint40",
        name: "heroLastActionTS",
        type: "uint40",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackStoryHeroStateId",
    outputs: [
      {
        internalType: "address",
        name: "heroAdr",
        type: "address",
      },
      {
        internalType: "uint80",
        name: "heroId",
        type: "uint80",
      },
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackStoryItemRequirement",
    outputs: [
      {
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        internalType: "bool",
        name: "requireItemBurn",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "requireItemEquipped",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackStoryNextPagesId",
    outputs: [
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "pageId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "heroClass",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "answerId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "resultId",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackStoryPageId",
    outputs: [
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "pageId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "heroClass",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackStorySimpleRequirement",
    outputs: [
      {
        internalType: "uint32",
        name: "randomRequirement",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "delayRequirement",
        type: "uint32",
      },
      {
        internalType: "bool",
        name: "isFinalAnswer",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackStoryTokenRequirement",
    outputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint88",
        name: "amount",
        type: "uint88",
      },
      {
        internalType: "bool",
        name: "requireTransfer",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "packedTierHero",
        type: "bytes32",
      },
    ],
    name: "unpackTierHero",
    outputs: [
      {
        internalType: "uint8",
        name: "tier",
        type: "uint8",
      },
      {
        internalType: "address",
        name: "hero",
        type: "address",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackUint32Array",
    outputs: [
      {
        internalType: "uint32[]",
        name: "",
        type: "uint32[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackUint8Array",
    outputs: [
      {
        internalType: "uint8[]",
        name: "",
        type: "uint8[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "data",
        type: "bytes32",
      },
    ],
    name: "unpackUint8Array3",
    outputs: [
      {
        internalType: "uint8",
        name: "a",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "b",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "c",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
] as const;

export class FacadePackingLib__factory {
  static readonly abi = _abi;
  static createInterface(): FacadePackingLibInterface {
    return new Interface(_abi) as FacadePackingLibInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): FacadePackingLib {
    return new Contract(address, _abi, runner) as unknown as FacadePackingLib;
  }
}
